import { FC } from "react";

import { ISoftValidationErrorBase, RydeUiUnit } from "@ryde/shared";

import { RideSoftValidationErrorItem } from "./parts";

interface ISoftValidationErrorItemProps {
  entity: RydeUiUnit;
  error: ISoftValidationErrorBase;
}

export const SoftValidationErrorItem: FC<ISoftValidationErrorItemProps> = ({
  entity,
  error,
}) => {
  switch (entity) {
    case "ride":
      return <RideSoftValidationErrorItem error={error} />;
    default:
      return null;
  }
};
